<div class="rate shadow-small">
    <h3 *ngIf="!finishedRating">{{ lang.data['guide_feedback.title'] }}</h3>

    <div *ngIf="!finishedRating" [innerHTML]="lang.data['guide_feedback.description']">
    </div>
    <div class="rate-actions" *ngIf="!showFeedback">
        <div class="rate-negative rate-action pointer shadow-small" (click)="rateGuide('negative')">
            <i class="fa fa-thumbs-down"></i>
        </div>
        <div class="rate-positive rate-action pointer shadow-small" (click)="rateGuide('positive')">
            <i class="fa fa-thumbs-up"></i>
        </div>
    </div>

    <div class="rate-feedback" *ngIf="showFeedback && !finishedRating">
        <ion-textarea placeholder="{{lang.data['block.rate.feedback_placeholder']}}"
                      [(ngModel)]="feedback"></ion-textarea>
        <ion-button class="button-gray" shape="round" expand="full" (click)="sendFeedback()">
            {{ lang.data['block.rate.send_feedback'] }}
        </ion-button>
    </div>

    <div class="confirm-feedback" *ngIf="finishedRating">
        {{ lang.data['feedback.confirmation'] }}
    </div>
</div>
